import React, { useState } from "react";
import {
  FaPlus,
  FaEllipsisV,
  FaSignOutAlt,
} from "react-icons/fa";
import InstallPWA from "./InstallPWA";
import CustomerList from "./CustomerList";
import DownloadProductExcelTemplate from "./DownloadExcelTemplateMenuItem";

function Header({
  user,
  onLogout,
  onAdd,
  onGenerateBilling,
  uploading,
  handleUpload,
  fileInputRef,
  showActionMenu,
  setShowActionMenu,
  actionMenuRef,
  syncStatus = "synced", // 'synced' | 'syncing' | 'offline'
  totalCount = 0,
  onCheckStatus,
  isOffline = false,
}) {
  const [showCustomers, setShowCustomers] = useState(false);
  const disabledOffline = isOffline || syncStatus === "offline";

  // Auto-close action menu if app transitions to offline
  React.useEffect(() => {
    if (disabledOffline && showActionMenu) {
      setShowActionMenu(false);
    }
  }, [disabledOffline, showActionMenu, setShowActionMenu]);

  return (
    <>
      <header className="pp-header">
        <div className="pp-headerInner">
          <div className="pp-brand">
            <img src="/mtlogo.jpg" alt="MT" className="pp-logo" />
            <h1 className="pp-title">MT Products</h1>

            {/* Online / Offline Status Badges */}
            {disabledOffline ? (
              <span
                className="pp-statusBadge pp-statusOffline"
                title="You are currently offline (Click to test connection)"
                onClick={onCheckStatus}
                style={{ cursor: "pointer" }}
              >
                🔴 Offline
              </span>
            ) : (
              <span
                className="pp-statusBadge pp-statusSynced"
                title="You are currently online (Click to test connection)"
                onClick={onCheckStatus}
                style={{ cursor: "pointer" }}
              >
                🟢 Online
              </span>
            )}
          </div>

          <div className="pp-actions" ref={actionMenuRef}>
            <button
              className="pp-btnPrimary"
              onClick={disabledOffline ? undefined : onAdd}
              type="button"
              disabled={disabledOffline}
              title={disabledOffline ? "Offline mode me Add disabled hai" : "Add Product"}
            >
              <FaPlus size={12} />
              Add
            </button>

            <button
              className="pp-btnIcon"
              onClick={(e) => {
                e.stopPropagation();
                if (!disabledOffline) {
                  setShowActionMenu((s) => !s);
                }
              }}
              type="button"
              disabled={disabledOffline}
              title={disabledOffline ? "Offline mode me Menu disabled hai" : "Actions Menu"}
            >
              <FaEllipsisV />
            </button>

            {showActionMenu && (
              <div className="pp-menu" onClick={(e) => e.stopPropagation()}>
                <div className="pp-menuHead">
                  <p className="pp-menuUser">{user?.username}</p>
                  <p className="pp-menuSub">Account</p>
                </div>

                <InstallPWA />

                <button
                  className="pp-menuBtn"
                  onClick={() => {
                    setShowActionMenu(false);
                    setShowCustomers(true);
                  }}
                  type="button"
                >
                  👥 View Customers
                </button>

                <button
                  className="pp-menuBtn"
                  onClick={() => {
                    setShowActionMenu(false);
                    onGenerateBilling();
                  }}
                  type="button"
                >
                  🧾 Approval Memo
                </button>

                <label className="pp-menuBtn pp-uploadLabel">
                  <span className="pp-menuEmoji">
                    {uploading ? "🔄" : "🆙"}
                  </span>
                  {uploading ? "Uploading..." : "Import Excel File"}

                  <input
                    ref={fileInputRef}
                    type="file"
                    accept=".xlsx,.xls,.csv"
                    onChange={() =>
                      fileInputRef.current?.files?.[0] && handleUpload()
                    }
                    disabled={uploading}
                    style={{ display: "none" }}
                  />
                </label>

                <DownloadProductExcelTemplate />

                <button
                  className="pp-menuBtn pp-menuBtnDanger"
                  onClick={() => {
                    setShowActionMenu(false);
                    onLogout();
                  }}
                  type="button"
                >
                  <FaSignOutAlt size={13} />
                  Logout
                </button>
              </div>
            )}
          </div>
        </div>
      </header>

      {showCustomers && (
        <div className="pp-customerModalOverlay">
          <div className="pp-customerModal">
            {/* Fixed header */}
            <div className="pp-customerModalHeader">
              <h2 className="pp-customerModalTitle">Customer List</h2>

              <button
                onClick={() => setShowCustomers(false)}
                className="pp-customerModalClose"
                type="button"
              >
                ✕
              </button>
            </div>

            {/* Scroll only body */}
            <div className="pp-customerModalBody">
              <CustomerList isModal />
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default Header;
